export default "__VITE_ASSET__dbb00728__"